import React from 'react';
import FullCalendar from '@fullcalendar/react';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { makeStyles } from '@material-ui/styles';
import { Box, Tooltip } from '@material-ui/core';
import KenDialog from '../../../global_components/KenDialogBox';
import ViewReferenceSession from './components/ViewReferenceSession';
import {
  CALENDAR_TYPES,
  EVENT_TYPES,
  RESOURCE_TYPES,
} from '../../../Utils/helper/schedulerHelper';
import SessionCreateUpdate from './components/SessionCreateUpdate';
import {
  ACTIONS,
  useSessionSchedulerContext,
} from '../../../Context/sessionSchedulerContext';
import moment from 'moment';
import Reference from './Reference';
import ResourceCalendar from './components/ResourceCalendar';
import { useAppContext } from '../../../Utils/context';

const useItemStyles = makeStyles((theme) => ({
  root: {
    '& > .MuiTreeItem-content': {
      height: '35px',
    },
    '& > .MuiTreeItem-content > .MuiTreeItem-label': {
      display: 'flex',
      alignItems: 'center',
      background: 'transparent !important',
      pointerEvents: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      padding: '0 15px 15px',
    },
    '& > .MuiTreeItem-content  > .MuiTreeItem-label::before': {
      content: "''",
      display: 'inline-block',
      minWidth: 15,
      minHeight: 15,
      marginRight: 8,
      border: '1px solid #ccc',
      background: 'white',
    },
  },
  iconContainer: {
    marginRight: 3,
    marginLeft: 0,
    '& > svg': {
      '&:hover': {
        opacity: 0.6,
      },
    },
  },
  label: {
    padding: 0,
  },
  selected: {
    '& > .MuiTreeItem-content  > .MuiTreeItem-label::before': {
      background: theme.palette.primary.main,
      // content: '\f095',
      border: '1px solid #ccc',
      // fontFamily: 'Font Awesome 5 Free',
    },
  },
  tooltipTable: {
    minWidth: ' 250px',
    maxWidth: '100%',
    borderCollapse: ' collapse',
    background: '#ffffff',
    padding: '10px',
  },
  tooltipTable_Tr: {
    height: '25px',
    color: '#7A869A',
    fontSize: '12px',
    background: '#fff',
  },
  tooltipTable_td: {
    height: '25px',
    paddingLeft: '10px',
    color: 'rgba(0, 0, 0, 0.87)',
    // background: '#f4f6fc',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    // borderLeft: '1px solid #303030',
    fontSize: '12px',
  },
  tooltipTable_th: {
    height: '25px',
    paddingLeft: '10px',
    color: 'rgb(9, 38, 130)',
    background: '#ffffff',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
  },
  resourceItem: {
    '&:hover': {
      color: theme.palette.KenColors.primary,
      fontWeight: 'bold',
      cursor: 'pointer',
    },
  },
}));

export default function Calendar(props) {
  const {
    state: {
      events,
      resources,
      resourceColumns = [],
      faculties = [],
      facilities = [],
      activityTypes,
      courseVersionData,
      term,
      isEventEdit,
      isEventView,
      selectedEvent,
      resourceType,
      selectedDetailedResource,
      calendarType,
    } = {},
    fetchDataByTerm,
    dispatch,
  } = useSessionSchedulerContext();

  const classesItem = useItemStyles();

  const calendarRef = React.useRef();
  const { handleSnackbarOpen } = useAppContext();

  const handleDateSelect = (e) => {
    console.log('Date select: ', e);
    // setSelectedDateData(
    //   _.pick(e, ['start', 'end', 'startStr', 'endstr', 'allDay'])
    // );
    if (!term) {
      // Term and other options validate and show message
      handleSnackbarOpen('error', 'Select term to create any activity');
      return;
    }
    // set selected event with start and end other info and edit flag to true
    dispatch({
      type: ACTIONS.SET_SELECTED_EVENT,
      value: {
        eventType:
          calendarType === CALENDAR_TYPES.SESSIONS
            ? EVENT_TYPES.SESSION
            : e?.allDay
            ? EVENT_TYPES.REFERENCE
            : EVENT_TYPES.ACTIVITY,
        startTime: getOnlyTimeFromDateString(e.startStr),
        startDate: getOnlyDateFromDateString(e.startStr),
        endDate: getOnlyDateFromDateString(e.endStr),
        endTime: getOnlyTimeFromDateString(e.endStr),
        FacultyBooking:
          resourceType === RESOURCE_TYPES.FACULTY
            ? { facultyId: e?.resource?.id }
            : null,
        FacilityBooking:
          resourceType === RESOURCE_TYPES.FACILITY
            ? { facilityId: e?.resource?.id }
            : null,
      },
    });
    dispatch({
      type: ACTIONS.SET_EVENT_EDIT_FLAG,
      value: true,
    });
  };

  // const handleEdit = (e) => {
  //   setSelectedEventEdit(true);
  //   setSelectedEvent(null);
  // };

  const getOnlyTimeFromDateString = function (str) {
    return moment(str).utc().format('HH:mm:ss');
  };
  const getOnlyDateFromDateString = function (str) {
    return moment(str).utc().format('YYYY-MM-DD');
  };
  const extractEventDetails = function (e) {
    const { event: { extendedProps, id, startStr, endStr } = {} } = e;
    let event = { ...extendedProps, id, startStr, endStr };
    console.log('ExtractEventDetails: ', event);

    // if (e?.eventType === EVENT_TYPES.REFERENCE) {
    //   return extended props only
    //
    // }
    if (
      event?.eventType === EVENT_TYPES.ACTIVITY ||
      event?.eventType === EVENT_TYPES.SESSION
    ) {
      // return extended props and start, end
      event['startDate'] = getOnlyDateFromDateString(startStr);
      event['endDate'] = getOnlyDateFromDateString(endStr);
      event['startTime'] = getOnlyTimeFromDateString(startStr);
      event['endTime'] = getOnlyTimeFromDateString(endStr);
    }

    return event;
  };

  const handleEventClick = (e) => {
    console.log('handleEventClick: ', extractEventDetails(e));
    // setEventAll(extractEventDetails(e));
    // setSelectedEvent(extractEventDetails(e));

    // save event in context: dispath event to store in context as selected event
    dispatch({
      type: ACTIONS.SET_SELECTED_EVENT,
      value: extractEventDetails(e),
    });
    dispatch({
      type: ACTIONS.SET_EVENT_VIEW_FLAG,
      value: true,
    });
  };

  const renderEventContent = (info = {}) => {
    console.log('renderEventContent: ', info);
    const { extendedProps } = info?.event;
    const toopTiptext = (
      <table className={classesItem.tooltipTable}>
        <tr className={classesItem.tooltipTable_Tr}>
          <th colSpan={2} className={classesItem.tooltipTable_th}>
            Activity Information
          </th>
          {/* <th className={classesItem.tooltipTable_th}></th> */}
        </tr>
        <tr>
          <th className={classesItem.tooltipTable_th}>Subject</th>
          <td className={classesItem.tooltipTable_td}>{info.event.title}</td>
        </tr>
        <tr>
          <th className={classesItem.tooltipTable_th}>Faculty</th>
          <td className={classesItem.tooltipTable_td}>
            {extendedProps?.FacultyBooking?.facultyName ||
              [
                extendedProps?.faculty1Name,
                extendedProps?.faculty2Name,
                extendedProps?.faculty3Name,
              ]
                .filter((f) => f)
                .join(',') ||
              'N/A'}
          </td>
        </tr>
        <tr>
          <th className={classesItem.tooltipTable_th}>Facility</th>
          <td className={classesItem.tooltipTable_td}>
            {info.event.extendedProps.facilityName ||
              extendedProps?.FacilityBooking?.facilityName ||
              'N/A'}
          </td>
        </tr>
      </table>
    );

    return (
      <Tooltip title={toopTiptext} placement="bottom">
        <div className="fc-event-title fc-sticky">
          {`${info.timeText} ${info.event?.title}`.trim()}
        </div>
      </Tooltip>
    );
  };
  const resourceClickHandler = function (r) {
    return (e) => {
      console.log('ResourceClicked: ', {
        resourceType,
        id: r?.resource?.id,
        name: r?.fieldValue,
      });

      if (r?.resource?.id) {
        dispatch({
          type: ACTIONS.SET_DETAILED_RESOURCE,
          value: {
            resourceType,
            id: r?.resource?.id,
            name: r?.fieldValue,
          },
        });
      }
    };
  };

  const renderResourceContent = (info) => {
    console.log('renderResourceContent: ', info);

    return (
      <Tooltip title={'Click to view details'}>
        <div
          className={classesItem.resourceItem}
          onClick={resourceClickHandler(info)}
        >
          {info.fieldValue}
        </div>
      </Tooltip>
    );
  };

  return (
    <Box>
      <FullCalendar
        ref={calendarRef}
        schedulerLicenseKey="0470008209-fcs-1655977369"
        headerToolbar={{
          left: 'prev,date,next today',
          center: 'title',
          right:
            'resourceTimelineDay,resourceTimelineWeek timeGridWeek,dayGridMonth',
        }}
        plugins={[
          resourceTimelinePlugin,
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
        ]}
        events={events}
        weekNumbers="true"
        resources={resources}
        // filterResourcesWithEvents="true"
        resourceAreaColumns={resourceColumns}
        initialView="resourceTimelineDay"
        allDaySlot={true}
        // timeZone="UTC"
        selectable={true} // false for stop click the event
        dayMaxEvents={true}
        selectLongPressDelay={1}
        select={handleDateSelect}
        eventClick={handleEventClick}
        // eventRender={renderEventContent}
        eventContent={renderEventContent}
        resourceLabelContent={renderResourceContent}
        // editable={true}
      />
      {/* EVENT VIEW MODAL */}
      <KenDialog
        open={!!selectedEvent && isEventView}
        hidePositiveButton={true}
        hideNegativeButton={true}
        maxWidth="sm"
        // fullWidth={false}
      >
        <ViewReferenceSession
          {...selectedEvent}
          onClose={() => {
            dispatch({ type: ACTIONS.CLEAR_SELECTED_EVENT });
          }}
        />
      </KenDialog>
      {/* EDIT EVENT : Session or Reference */}

      {!!selectedEvent &&
        isEventEdit &&
        (selectedEvent?.eventType === EVENT_TYPES.ACTIVITY ||
          selectedEvent?.eventType === EVENT_TYPES.SESSION) && (
          <KenDialog
            // open={!!selectedDateData}
            handleClose={() => {
              dispatch({ type: ACTIONS.CLEAR_SELECTED_EVENT });
            }}
            open={
              !!selectedEvent &&
              isEventEdit &&
              (selectedEvent?.eventType === EVENT_TYPES.ACTIVITY ||
                selectedEvent?.eventType === EVENT_TYPES.SESSION)
            }
            onClose={() => {}}
            maxWidth="sm"
            fullWidth={false}
            dialogActions={<></>}
            // title="Add Acitivity"
            divider
          >
            <SessionCreateUpdate
              event={selectedEvent}
              term={term}
              faculties={faculties}
              facilities={facilities}
              activityTypes={activityTypes}
              courseVersionData={courseVersionData}
              onCancel={() => {
                // setSelectedDateData(null);
                dispatch({ type: ACTIONS.CLEAR_SELECTED_EVENT });
              }}
              onSuccess={() => {
                fetchDataByTerm(term, { hasToGetVersion: false });
                // setSelectedDateData(null);
                dispatch({ type: ACTIONS.CLEAR_SELECTED_EVENT });
              }}
            />
          </KenDialog>
        )}

      {!!selectedEvent &&
        isEventEdit &&
        selectedEvent?.eventType === EVENT_TYPES.REFERENCE && (
          <Reference
            title={'Reference'}
            isOpen={
              !!selectedEvent &&
              isEventEdit &&
              selectedEvent?.eventType === EVENT_TYPES.REFERENCE
            }
            handleClose={() => {
              dispatch({ type: ACTIONS.CLEAR_SELECTED_EVENT });
            }}
            subjects={courseVersionData?.map((s) => ({
              value: s.id,
              label: s.courseName,
            }))}
            facultyOptions={faculties?.map((f) => ({
              label: f.facultyName,
              value: f.id,
            }))}
            event={selectedEvent}
            termId={term}
            activityTypes={activityTypes}
            onSuccess={() => {
              fetchDataByTerm(term, { hasToGetVersion: false });
              dispatch({ type: ACTIONS.CLEAR_SELECTED_EVENT });
            }}
          />
        )}

      {selectedDetailedResource?.id && (
        <KenDialog
          title={`${selectedDetailedResource?.name} Booked Slots`}
          open={selectedDetailedResource?.id}
          maxWidth="md"
          hideNegativeButton
          positiveButtonClick={() => {
            dispatch({
              type: ACTIONS.CLEAR_DETAILED_RESOURCE,
            });
          }}
        >
          <ResourceCalendar
            {...selectedDetailedResource}
            calendarType={calendarType}
          />
        </KenDialog>
      )}
    </Box>
  );
}
